import { jsx as _jsx } from "react/jsx-runtime";
import { useLanguage } from "@/app";
import { translations } from "@/widgets/web/sidebar/constants";
import { Modal } from "@/shared/ui";
import { trackEvent } from "@/shared/lib/analytics";
import { AnalyticsEvent } from "@/shared/lib/analyticsEvents";
import { YM_GOAL_CHECKOUT_OPEN, ymReachGoalOnce, } from "@/shared/lib/yandexMetrika";
import { useEffect } from "react";
import { BuyPackageCard } from "../BuyPackageCard/BuyPackageCard";
import styles from "./BuyPackageModal.module.scss";
export const BuyPackageModal = ({ isTopUpModalOpen, setIsTopUpModalOpen, isLoadingPackages, packages, }) => {
    const { language } = useLanguage();
    const t = translations[language];
    // Открыт попап тарифов = просмотр списка пакетов (контракт: одно packages_view
    // и на странице баланса, и на этом попапе — отдельного события нет).
    useEffect(() => {
        if (isTopUpModalOpen) {
            trackEvent(AnalyticsEvent.PACKAGES_VIEW);
            // Ступень воронки Метрики (см. yandexMetrika). Once: модалку открывают и
            // закрывают по нескольку раз за визит, а воронка считает визиты.
            ymReachGoalOnce(YM_GOAL_CHECKOUT_OPEN, { placement: "topup_modal" });
        }
    }, [isTopUpModalOpen]);
    return (_jsx(Modal, { opened: isTopUpModalOpen, onClose: () => setIsTopUpModalOpen(false), title: t.topUpBalance, size: "lg", children: isLoadingPackages ? (_jsx("div", { className: styles.stateRow, children: _jsx("span", { className: styles.stateText, children: t.loadingPackages }) })) : packages.length === 0 ? (_jsx("div", { className: styles.stateRow, children: _jsx("span", { className: styles.stateText, children: language === "ru" ? "Пакеты не найдены" : "No packages found" }) })) : (_jsx("div", { className: styles.cardsGrid, children: packages.map((packageItem) => (_jsx(BuyPackageCard, { packageItem: packageItem, setIsTopUpModalOpen: setIsTopUpModalOpen }, packageItem.id))) })) }));
};
